var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{attrs:{"id":_vm.name ? _vm.name : false}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n    "),(_vm.fieldRequired)?_c('span',[_vm._v("(required)")]):_vm._e()]),(_vm.description)?_c('doe-paragraph',{attrs:{"description":_vm.description}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }